import axios, { resHandle } from "@/plugins/axios";

/**
 * @description 四诊设备-导入患者
 * @param vCom Vue组件
 * @param params post参数
 */
const PostImportHospatients = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/project/import/hospatients", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};


const GetGroupsOfProject = (vCom: any, projectId: string): Promise<any> => {
    const params: any = {
        params: {
            project_id: projectId
        }
    };
    return new Promise((resolve, reject) => {
        axios.get("api/project/groups", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};



export { PostImportHospatients, GetGroupsOfProject };

